<div class="flex flex-wrap gap-sm align-items-center p-control">
  <ng-content></ng-content>
  <vnm-form-field
    [label]="label"
    [info]="info"
    [help]="help"
    [disabled]="switchControl?.disabled"
    (tooltipClicked)="tooltipClicked.emit()"
  ></vnm-form-field>
  <ng-content select="[altControl]"></ng-content>
  <button
    *ngIf="configLink"
    type="button"
    pButton
    class="p-button-text ml-auto"
    icon="fa fa-fw fa-cogs"
    [routerLink]="configLink"
    [disabled]="!switchControl?.checked()"
  ></button>
</div>
